<template>
<div>
  <div class="car-details-card show" v-for="vehicle in loadVehicles" :key="vehicle.id">
    <div class="top-ctr flex flex-col md:flex-row justify-center lg:justify-start">
      <div class="details">
        <h3>{{ vehicle.title }}</h3>
        <!-- <h5>{{ vehicle.price }}</h5> -->
        <!-- <p>{{ vehicle.subtitle }}</p> -->
        <h5>{{ vehicle.subtitle }}</h5>
        <!-- <div class="wysiwyg" v-html="vehicle.description"></div> -->
        <read-moreable :max-height="140">
            <template #default>
                <div class="wysiwyg" v-html="vehicle.description"></div>
            </template>
        </read-moreable>
        <button @click="bookNow" class="button large red booknow">Book Now</button>
      </div>
      <div class="gallery">
        <VueSlickCarousel ref="carousel" v-if="vehicle.images.length > 0" v-bind="settings">
          <article v-for="image in vehicle.images" :key="image">
            <img :src="image" alt="Car Image" />
          </article>
        </VueSlickCarousel>
      </div>
    </div>
    <div class="bottom-ctr">
      <div class="features flex flex-row justify-start">
        <div class="feature">
          <h4 class="feature-title">Passengers</h4>
          <div class="feature-description passengers-icon flex flex-row items-center">
            <img src="/images/passengers-2.svg" alt="Passengers" />
            <p class="feature-description">{{ vehicle.passengers }}</p>
          </div>
        </div>
        <div class="feature" v-if="vehicle.suitcase_large_size !== 0 || vehicle.suitcase_medium_size !== 0 || vehicle.suitcase_small_size !== 0 || vehicle.softbag_size !== 0">
          <h4 class="feature-title">Suitcases</h4>
          <!-- large -->
          <div class="feature-description suitcase-icon flex flex-row" v-if="vehicle.suitcase_large_size > 0">
            <img src="/images/vehicles/suitcases.svg" alt="Suitcases" />
            <p class="feature-description">{{ vehicle.suitcase_large_size }} Large</p>
          </div>

          <!-- medium -->
          <div class="feature-description suitcase-icon flex flex-row" v-if="vehicle.suitcase_medium_size > 0">
            <img src="/images/vehicles/suitcases.svg" alt="Suitcases" />
            <p class="feature-description">{{ vehicle.suitcase_medium_size }} Medium</p>
          </div>

          <!-- small -->
          <div class="feature-description suitcase-icon flex flex-row" v-if="vehicle.suitcase_small_size > 0">
            <img src="/images/vehicles/suitcases.svg" alt="Suitcases" />
            <p class="feature-description">{{ vehicle.suitcase_small_size }} Small</p>
          </div>
          
          <!-- softbag -->
          <div class="feature-description suitcase-icon flex flex-row" v-if="vehicle.softbag_size > 0">
            <img src="/images/vehicles/suitcases.svg" alt="Suitcases" />
            <p class="feature-description">{{ vehicle.softbag_size }} Soft bag</p>
          </div>


        </div>
        <div class="feature" v-if="vehicle.transmission !== ''">
          <h4 class="feature-title">Transmission</h4>
          <p>{{ vehicle.transmission }}</p>
        </div>
      </div>
    </div>
  </div>

  <div class="load-more-container text-center mt-4 mb-4" v-if="!hideLoadMore">
      <button class="button large red-border" @click="loadMore">
          Load more
      </button>
  </div>

</div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import ReadMoreable from "./ReadMoreable.vue";

export default {
  components: {
    VueSlickCarousel,
    ReadMoreable,
  },

  props: {
    vehicles: {
      type: Array,
    },
  },

  data() {
    return {
      loadVehicles: [],
      hideLoadMore: false,
      settings: {
        arrows: true,
        dots: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    };
  },

  mounted() {
    console.log(this.vehicles);

    if(this.vehicles.length === 0) {
      this.hideLoadMore = true;
    }

    this.loadVehicles = this.vehicles.slice(0, 2);
  },

  methods: {
    bookNow() {
      window.location.href = "/booking";
    },
    loadMore() {
      this.loadVehicles = this.vehicles.slice(0, this.loadVehicles.length + 3);
      if (this.loadVehicles.length >= this.vehicles.length) {
        this.hideLoadMore = true;
      }
    },
  },
};
</script>

<style scoped>
button.booknow {
  margin-top:10px;
}
</style>
